console.log('Cart Working loaded');

// Funktion um aktuelle Sprache zu ermitteln
function getCurrentLocale() {
    // Versuche verschiedene Methoden um die aktuelle Sprache zu ermitteln
    var htmlLang = document.documentElement.lang;
    var urlLang = window.location.pathname.split('/')[1];
    
    // Prüfe ob URL-Pfad eine Sprache enthält
    if (['en', 'es', 'fr', 'de'].includes(urlLang)) {
        return urlLang;
    }
    
    // Fallback auf HTML lang Attribut
    if (htmlLang && htmlLang.length >= 2) {
        return htmlLang.substring(0, 2);
    }
    
    return 'de'; // Standard Fallback
}

// Funktion um Banner-Texte basierend auf Sprache zu holen
function getBannerTexts(locale) {
    var texts = {
        'en': {
            banner1: "🎵 Buy 5 tracks, get 15% discount automatically!",
            banner2: "🎶 From 6 tracks -> 20% discount!"
        },
        'es': {
            banner1: "🎵 ¡Compra 5 pistas, obtén 15% de descuento automáticamente!",
            banner2: "🎶 ¡Desde 6 pistas -> 20% de descuento!"
        },
        'fr': {
            banner1: "🎵 Achetez 5 titres, obtenez 15% de réduction automatiquement!",
            banner2: "🎶 À partir de 6 titres -> 20% de réduction!"
        },
        'de': {
            banner1: window.metaobjectBanner1 || "🎵 Kaufe 5 Titel, erhalte 15% Rabatt!",
            banner2: window.metaobjectBanner2 || "🎶 Ab 6 Titel -> 20% Rabatt!"
        }
    };
    
    return texts[locale] || texts['de'];
}

function addBanners() {
    console.log('Looking for cart page...');
    
    var cartForm = document.querySelector('form[action="/cart"]');
    var cartHeader = document.querySelector('.cart__header') || 
                    document.querySelector('.cart-header') || 
                    document.querySelector('h1') ||
                    document.querySelector('.page-title');
    
    console.log('Cart form found:', cartForm);
    console.log('Cart header found:', cartHeader);
    
    if (cartHeader && window.location.pathname.includes('/cart')) {
        var currentLocale = getCurrentLocale();
        var bannerTexts = getBannerTexts(currentLocale);
        
        console.log('Current locale detected:', currentLocale);
        
        // Entferne existierende Banner
        var existingBanner1 = document.getElementById('banner-1');
        var existingBanner2 = document.getElementById('banner-2');
        if (existingBanner1) existingBanner1.remove();
        if (existingBanner2) existingBanner2.remove();
        
        // Banner 1
        var testDiv = document.createElement('div');
        testDiv.id = 'banner-1';
        testDiv.innerHTML = bannerTexts.banner1;
        testDiv.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
        testDiv.style.color = 'white';
        testDiv.style.padding = '15px';
        testDiv.style.textAlign = 'center';
        testDiv.style.fontWeight = 'bold';
        testDiv.style.marginBottom = '15px';
        
        cartHeader.insertAdjacentElement('afterend', testDiv);
        console.log('Banner 1 added to cart page');
        
        // Banner 2
        var testDiv2 = document.createElement('div');
        testDiv2.id = 'banner-2';
        testDiv2.innerHTML = bannerTexts.banner2;
        testDiv2.style.background = '#28a745';
        testDiv2.style.color = 'white';
        testDiv2.style.padding = '12px';
        testDiv2.style.textAlign = 'center';
        testDiv2.style.fontWeight = 'bold';
        testDiv2.style.marginBottom = '15px';
        
        testDiv.insertAdjacentElement('afterend', testDiv2);
        console.log('Banner 2 added to cart page');
    }
}

// Nur auf der Warenkorb-Seite ausführen
if (window.location.pathname.includes('/cart')) {
    setTimeout(addBanners, 1000);
    setTimeout(addBanners, 3000);
    
    // Überwache Änderungen am DOM (für Sprachumschalter)
    var observer = new MutationObserver(function(mutations) {
        setTimeout(addBanners, 500);
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

console.log('Cart Working ready');
